// removed by extract-text-webpack-plugin
module.exports = {"page-cards":"_1q5PL","card":"_22VOu","action":"_2R3-6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedPages.less
// module id = ./src/components/Home/FeaturedPages.less
// module chunks = 2